import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["StateMessage", {
            'StateMessage--error': _ctx.isError,
            'StateMessage--showed': Boolean(_ctx.message)
        }])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          class: _normalizeClass({ 'primary': !_ctx.isError })
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    (Boolean(_ctx.message))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createTextVNode(_toDisplayString('<empty message>'))
        ], 64))
  ], 2))
}